import { types, INITIAL_STATE } from '../constants';

const API_TYPE = 'api';
const ASYNC_API_TYPE = 'async';

export function combineReducers(reducers) {
  const keys = Object.keys(reducers).filter(key => {
    return typeof reducers[key] === 'function';
  });

  return function masterReducer(state = INITIAL_STATE, action) {
    if (action && action.type) {
      const newState = { ...state };
      keys.forEach(key => {
        const previousStateForKey = newState[key];
        const newStateForKey = reducers[key](previousStateForKey, action);
        if (previousStateForKey !== newStateForKey) {
          newState[key] = newStateForKey;
        }
      });
      return newState;
    }
    throw new Error('Action is invalid!');
  };
}

function domainsReducer(state = {}, action) {
  switch (action.type) {
    case types.GET_DOMAINS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_DOMAINS_RECEIVE:
      return {
        ...state,
        data: action.response,
        loading: false
      };
    case types.GET_DOMAINS_ERROR:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

function apiReducer(state = {}, action) {
  switch (action.type) {
    case types.GET_APIS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_APIS_RECEIVE:
      return {
        ...state,
        data: action.response?.items?.filter(item => item.apiType === API_TYPE),
        // orgData: action.response.orgs,
        bundles: action.response.bundles,
        loading: false
      };
    case types.GET_APIS_ERROR:
      return {
        ...state,
        loading: false
      };
    case types.GET_API_PAGES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_API_PAGES_RECEIVE:
      return {
        ...state,
        data: [
          ...state.data,
          ...action.response?.items?.filter(item => item.apiType === API_TYPE)
        ],
        loading: false
      };
    case types.GET_API_PAGES_ERROR:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

//With the combined query being used now we can set this reducer to look for the same actions as the apiReducer
function asyncApiReducer(state = {}, action) {
  switch (action.type) {
    case types.GET_APIS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_APIS_RECEIVE:
      return {
        ...state,
        data: action.response?.items?.filter(
          item => item.apiType === ASYNC_API_TYPE
        ),
        loading: false
      };
    case types.GET_APIS_ERROR:
      return {
        ...state,
        loading: false
      };
    case types.GET_API_PAGES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GET_API_PAGES_RECEIVE:
      return {
        ...state,
        data: [
          ...state.data,
          ...action.response?.items?.filter(
            item => item.apiType === ASYNC_API_TYPE
          )
        ],
        loading: false
      };
    case types.GET_API_PAGES_ERROR:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

export default combineReducers({
  domains: domainsReducer,
  apis: apiReducer,
  asyncApis: asyncApiReducer
});
